import { useCallback, useState } from 'react';
import { FiDownload, FiFileText, FiTrash2, FiUpload } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import Upload from 'Components/Upload';
import { DOWNLOAD_UPLOADED_PRESIGNED_FILE, UPLOAD_DOCUMENT } from 'Constants/actionConstants';
import './DocumentCell.scss';

const DocumentCell = ({ documents = [], branchId, onChange, enableUpload}) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    const fetchDownloadUrl = useCallback((fileName) => {
        dispatch({
            type: DOWNLOAD_UPLOADED_PRESIGNED_FILE,
            param: { fileName },
            skipDownload: true,
            onSuccess: (url) => {
                if (url) {
                    onChange(branchId, [...documents, { file_name: fileName, downloadUrl: url }]);
                }
            },
        });
    }, [dispatch, branchId, documents, onChange]);

    const handleUpload = useCallback((file) => {
        if (!file) return;
        dispatch({
            type: UPLOAD_DOCUMENT,
            file,
            onSuccess: (response) => {
                if (response?.name) {
                    fetchDownloadUrl(response.name);
                }
            },
        });
    }, [dispatch, fetchDownloadUrl]);

    const handleUserDownload = useCallback((doc) => {
        if (!doc?.downloadUrl) return;
        const link = document.createElement('a');
        link.href = doc.downloadUrl;
        link.download = doc.file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, []);

    const handleDelete = useCallback((fileName) => {
        onChange(branchId, documents.filter(doc => doc.file_name !== fileName));
    }, [branchId, documents, onChange]);

    return (
        <div className="doc-cell">
            <span className="doc-trigger" onClick={() => setOpen(prev => !prev)}>
                <FiFileText />
                {documents.length > 0 && (
                    <span className="count">+{documents.length}</span>
                )}
            </span>

            {enableUpload && (
                <Upload onChange={handleUpload} fileSize={40} className="upload-icon">
                    <FiUpload />
                </Upload>
            )}

            {open && (
                <div className="doc-popover">
                    <div className="title">
                        Attached Documents
                        <span className="sub">{documents.length} files</span>
                    </div>

                    {documents.length === 0 && (
                        <div className="empty">No documents uploaded</div>
                    )}

                    {documents.map((doc) => (
                        <div key={doc.file_name} className="doc-row">
                            <span className="name">{doc.file_name}</span>
                            <div className="actions">
                                <FiDownload
                                    className="icon"
                                    onClick={() => handleUserDownload(doc)}
                                />
                                {!doc.fromApi && (
                                    <FiTrash2
                                        className="icon delete"
                                        onClick={() => handleDelete(doc.file_name)}
                                    />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DocumentCell;
